export default function (context, {cb}) {
    context.commit('clean');
    context.commit('loading', true);

    axios({
        method: 'GET',
        url: '/tourclient/order/sendedMails?_=' + new Date().getTime(),
    }).then(({data}) => {
        context.commit('set', data.NotReadedCount);
        context.commit('loading', false);
        if(cb) cb(context.state);
    }).catch(data => {
        context.commit('loading', false);
        context.dispatch('error', data, {root: true});
    });
}